import { motion, useReducedMotion } from 'framer-motion'
import { PropsWithChildren } from 'react'

interface Props {
  id?: string
  delay?: number
  y?: number
  className?: string
}

const Reveal = ({
  children,
  id,
  delay = 0,
  y = 24,
  className,
}: PropsWithChildren<Props>) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      id={id}
      className={className}
      initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}

export default Reveal
